(function() {
  'use strict';

  angular
    .module('quiz.labelingItemsInPicture')
    .factory('BoxCaptionPositionCalculator', BoxCaptionPositionCalculator);

  BoxCaptionPositionCalculator.$inject = [];

  function BoxCaptionPositionCalculator() {
    var boxes = [];
    var _longestCaptionWidth = 0;
    var _captionHeight = 0;
    var _containerBoxRect = 0;
    var _leftOverflowRectangle = 0;
    var _rightOverflowRectangle = 0;
    var _captionOverlapWidth = 0;
    var _regionBorderWidth = 0;

    var xOffset = 28;
    var yOffset = 28;

    function setCaptionPositions(regions, longestCaptionWidth, captionHeight, containerBoxSize, leftOverflowRectangle, rightOverflowRectangle, captionOverlapWidth, regionBorderWidth) {
      _longestCaptionWidth = longestCaptionWidth;
      _captionHeight = captionHeight;
      _containerBoxRect = containerBoxSize;
      _leftOverflowRectangle = leftOverflowRectangle;
      _rightOverflowRectangle = rightOverflowRectangle;
      _captionOverlapWidth = captionOverlapWidth;
      _regionBorderWidth = regionBorderWidth;

      _containerBoxRect.x = 0;
      _containerBoxRect.y = 0;
      _leftOverflowRectangle.x = -_leftOverflowRectangle.width;
      _rightOverflowRectangle.x = _containerBoxRect.width;

      boxes = createBoxes(regions);
      calculatePossibleCaptionPositions();
      sortAnswerBoxesFromLeastNumberOfAnswerPositionsToMost();

      _.each(boxes, function(box) {
        box.chosenAnswerPosition = determineAnswerPositionForAnswerBox(box);
        box.region.captionPosition = box.chosenAnswerPosition;

        box.region.captionPosition.x += xOffset;
        box.region.captionPosition.y += yOffset;
      })
    }

    function determineAnswerPositionForAnswerBox(box) {
      if (box.avaliablePositions.length == 1) {
        return box.avaliablePositions[0];
      }
      else {
        return findAnswerPositionToUse(box);
      }
    }

    function findAnswerPositionToUse(box) {
      var answerPositionToUse = findAnswerPositionThatHasNoChanceOfBeingBlocked(box);

      if (answerPositionToUse == null)
        answerPositionToUse = findAnswerPositionThatHasNotBeenBlockedSoFar(box);

      if (answerPositionToUse == null)
        answerPositionToUse = findAnswerPositionWithMostNotBlockedArea(box);

      return answerPositionToUse;
    }


    function findAnswerPositionThatHasNoChanceOfBeingBlocked(box) {
      return _.find(box.avaliablePositions, function(position) {
        return positionDoesNotConflictWithAnyOtherBox(box, position);
      });
    }

    function positionDoesNotConflictWithAnyOtherBox(boxBeingTested, position) {
      var conflict = _.find(boxes, function(box) {
        return box != boxBeingTested && positionConflictsWithAnswerBox(position, box);
      });
      return conflict == null;
    }

    function positionConflictsWithAnswerBox(position, box) {
      var conflict = _.find(box.avaliablePositions, function(checkPosition) {
        return positionsConflict(position, checkPosition);
      });

      return conflict != null;
    }

    function positionsConflict(aPos, bPos) {
      var a_LeftEdge = aPos.x;
      var a_TopEdge = aPos.y;
      var a_RightEdge = a_LeftEdge + aPos.width;
      var a_BottomEdge = a_TopEdge + aPos.height;

      var b_LeftEdge = bPos.x;
      var b_TopEdge = bPos.y;
      var b_RightEdge = b_LeftEdge + bPos.width;
      var b_BottomEdge = b_TopEdge + bPos.height;

      return !(a_RightEdge < b_LeftEdge ||
      a_LeftEdge > b_RightEdge ||
      a_TopEdge >= b_BottomEdge ||
      a_BottomEdge <= b_TopEdge);
    }

    function findAnswerPositionThatHasNotBeenBlockedSoFar(box) {
      return _.find(box.avaliablePositions, function(position) {
        return conflictingPositionHasNotAlreadyBeenChosenByAnotherAnswerBox(box, position)
      })
    }

    function findAnswerPositionWithMostNotBlockedArea(box) {
      var positionsWithNonBlockedAreas = _.map(box.avaliablePositions, function(position) {
        return {
          position: position,
          nonBlockedArea: calculateNonBlockedAreaForPosition(position, box)
        }
      });

      positionsWithNonBlockedAreas = _.sortBy(positionsWithNonBlockedAreas, function(data) {
        return -data.nonBlockedArea
      });
      return positionsWithNonBlockedAreas[0].position;
    }

    function calculateNonBlockedAreaForPosition(position, parentBox) {
      var blockedPositionAreas = findAllBlockedAreasForPosition(position, parentBox);
      var maxBlockArea = _.max(blockedPositionAreas, function(area) {
        return area.width * area.height
      });

      return position.width * position.height - maxBlockArea.width * maxBlockArea.height;
    }


    function findAllBlockedAreasForPosition(position, parentBox) {
      var blockedPositionAreas = [];
      _.each(boxes, function(box) {
        if (box != parentBox && box.chosenAnswerPosition && positionsConflict(box.chosenAnswerPosition, position)) {
          blockedPositionAreas.push(findIntersection(box.chosenAnswerPosition, position));
        }
      });
      return blockedPositionAreas;
    }

    function findIntersection(posA, posB) {
      var leftX = Math.max(posA.x, posB.x);
      var topY = Math.max(posA.y, posB.y);
      var rightX = Math.min(posA.x + posA.width, posB.x + posB.width);
      var bottomY = Math.min(posA.y + posA.height, posB.y + posB.height);


      return {
        x: leftX,
        y: topY,
        width: rightX - leftX,
        height: bottomY - topY
      };
    }

    function conflictingPositionHasNotAlreadyBeenChosenByAnotherAnswerBox(boxBeingTested, position) {
      var conflict = _.find(boxes, function(box) {
        return box != boxBeingTested && answerBoxHasAlreadyChosenConflictingPosition(position, box);
      });
      return conflict == null;
    }

    function answerBoxHasAlreadyChosenConflictingPosition(position, box) {
      var allConflictingPositions = getConflictingPositions(position, box);

      var blocked = _.find(allConflictingPositions, function(conflictingPosition) {
        return conflictingPosition == box.chosenAnswerPosition;
      });

      return blocked != null;
    }

    function getConflictingPositions(position, box) {
      return _.filter(box.avaliablePositions, function(checkPosition) {
        return positionsConflict(checkPosition, position);
      });
    }


    function createBoxes(regions) {
      return _.map(regions, function(region) {
        return {
          region: region,
          x: region.x,
          y: region.y,
          width: region.width,
          height: region.height,
          left: region.x,
          right: region.x + region.width,
          top: region.y,
          bottom: region.y + region.height
        };
      })
    }

    function calculatePossibleCaptionPositions() {
      var needsWidth = _longestCaptionWidth - _captionOverlapWidth;

      _.each(boxes, function(box) {
        box.avaliablePositions = [];
        var numberOfSlots = Math.max(Math.floor(box.height / _captionHeight), 1);
        for (var i = 0; i < numberOfSlots; i++) {
          var rightBorder =
            {
              x1: box.right - _captionOverlapWidth + _longestCaptionWidth,
              y1: box.y + i * _captionHeight
            };
          rightBorder.x2 = rightBorder.x1;
          rightBorder.y2 = rightBorder.y1 + _captionHeight;

          if (rectContainsLine(_containerBoxRect, rightBorder) ||
            rectContainsLine(_rightOverflowRectangle, rightBorder)) {
            box.avaliablePositions.push({
              x: rightBorder.x1 - _longestCaptionWidth,
              y: rightBorder.y1,
              width: _longestCaptionWidth,
              height: _captionHeight,
              right: true
            });
          }

          var leftBorder =
            {
              x1: box.x - needsWidth,
              y1: box.y + i * _captionHeight
            };
          leftBorder.x2 = leftBorder.x1;
          leftBorder.y2 = leftBorder.y1 + _captionHeight;

          if (rectContainsLine(_containerBoxRect, leftBorder) ||
            rectContainsLine(_leftOverflowRectangle, leftBorder)) {
            box.avaliablePositions.push({
              x: leftBorder.x1,
              y: leftBorder.y1,
              width: _longestCaptionWidth,
              height: _captionHeight,
              left: true
            });
          }
        }

        if (box.avaliablePositions.length == 0) {
          box.avaliablePositions.push({
            x: box.right - _longestCaptionWidth + _regionBorderWidth,
            y: box.y + _regionBorderWidth,
            width: _longestCaptionWidth,
            height: _captionHeight,
            left: true
          });
        }
      })
    }

    function sortAnswerBoxesFromLeastNumberOfAnswerPositionsToMost() {
      boxes = _.sortBy(boxes, function(box) {
        return box.avaliablePositions.length;
      })
    }

    function rectContainsPoint(rect, x, y) {
      return x >= rect.x && x <= (rect.x + rect.width) &&
        y >= rect.y && y <= (rect.y + rect.height);
    }

    function rectContainsLine(rect, line) {
      return rectContainsPoint(rect, line.x1, line.y1) && rectContainsPoint(rect, line.x2, line.y2);
    }

    return {
      setCaptionPositions: setCaptionPositions
    };
  }
})();
